<script lang="ts">
    import { Col, Nav, NavItem, NavLink } from "sveltestrap";
    import { Base, InlineNav } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import FeatherIcon from "svelte-feather-icon";
    import data from "../../../Data/ComponentData/Ui-kits/Navs/Navs.json"
</script>
<Col xl="6" lg="12" class="xl-40">
    <Card cardHeaderprops="pb-0" headerTitle={InlineNav}>
      <div slot="contentbody">
        <Nav vertical class="icon-lists border navs-icon inline-nav">
            <NavItem>
                <NavLink>
                    <FeatherIcon icon="box"/>
                    <span> {Base}</span>
                </NavLink>
            </NavItem>
            {#each data.inlineNavdata as navItem }
                <NavItem class="pl-navs-inline">
                    <NavLink>
                        <i class="fa fa-angle-right"/>
                        <span> {navItem.name}</span>
                    </NavLink>
                </NavItem>
            {/each}
        </Nav>
      </div>
    </Card>
</Col>